<template>
  <vx-card style="min-height: 0px">
    <p class="text-justify text-xs">
      {{ indicatorDisclaimerText }}
    </p>
  </vx-card>
</template>

<script>
import config from "@/config/alquant";

export default {
  name: "IndicatorDisclaimerCard",
  computed: {
    indicatorDisclaimerText() {
      return config.indicatorDisclaimerText;
    },
  },
};
</script>
